import { useState } from 'react';
import { toast } from 'react-toastify';
import Axios from '../utils/axiosInstance';

const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to send the reset password email
  const sendResetEmail = async (email) => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}api/forgot-password/`;
      const response = await Axios.post(apiUrl, { email });
      if (response.data.success) {
        toast.success("Reset email sent successfully!");
        return response.data;
      } else {
        throw new Error(response.data.message || "Failed to send reset email");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to confirm the new password
  const confirmNewPassword = async (token,newPassword,uid) => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}api/reset-password/`;
      const response = await Axios.post(apiUrl, { new_password: newPassword, token: token, uid: uid });
      if (response.data.success) {
        toast.success("Password reset successfully!");
        return response.data;
      } else {
        throw new Error(response.data.message || "Password reset failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { sendResetEmail, confirmNewPassword, loading, error };
};

export default useResetPassword;
